// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LanguageSwitcherModal-cls1__d89d3f6204f702cbb3cc{/*!*/}.LanguageSwitcherModal-cls2__e6f417ccfc5c1b3b100e{display:flex;flex-direction:column;justify-content:space-around;background:#fff;border-radius:4px;margin-bottom:35vh}@media only screen and (max-width: 560px){.LanguageSwitcherModal-cls2__e6f417ccfc5c1b3b100e{max-width:80vw;max-height:40vh}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "LanguageSwitcherModal-cls1__d89d3f6204f702cbb3cc",
	"cls2": "LanguageSwitcherModal-cls2__e6f417ccfc5c1b3b100e LanguageSwitcherModal-cls1__d89d3f6204f702cbb3cc"
};
export default ___CSS_LOADER_EXPORT___;
